import { CartItem } from '@/context/ShoppingCartContext';

import { useEffect, useState } from 'react';

export function useLocalStorage(key: string, initialValue: CartItem[] | (() => []) | null) {
  const [value, setValue] = useState<CartItem[]>(() => {
    if (typeof window !== 'undefined') {
      const jsonValue = localStorage.getItem(key);

      if (jsonValue != null) {
        return JSON.parse(jsonValue);
      }

      if (typeof initialValue === 'function') {
        return (initialValue as () => [])();
      } else {
        return initialValue;
      }
    }
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue] as [typeof value, typeof setValue];
}
